<template>
  <div class="about">
    <h1 class="px-6 pt-6 pb-4 text-2xl sm:px-10 lg:px-16 title">
      Support
    </h1>
    <div
      class="px-6 overflow-auto sm:px-10 lg:px-16"
      :style="{ height: 'calc(100vh - 150px)' }"
    >
      <p>
        For questions about POS Dashboard, or if you're in need of technical support,
        please contact our support team using the following form:
        <a
          target="_blank"
          :href="`https://form.asana.com/?k=c0HEihFERBMHuJWJUjxqYw&d=9100179247847`"
          class="text-blue-400 hover:opacity-75"
        >
          contact form.
        </a>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SupportPage',

  setup () {
    const supportEmail = 'data_growth_together@carrefour.com'

    return {
      publicPath: process.env.BASE_URL,
      supportEmail
    }
  }
}
</script>

<style lang="postcss" scoped>
.play:after {
  content: "";
  display: block;
  position: absolute;
  top: 10.5px;
  left: 24px;
  margin: 0 auto;
  border-style: solid;
  border-width: 9.5px 0 9.5px 17px;
  border-color: transparent transparent transparent rgba(255, 255, 255, 1);
}
</style>

<style scoped>
.title {
  color: #3a4245;
}
</style>
